import { useQuery } from "react-query";
import dayjs from "dayjs";
import { AppConstant, KeyConstant } from "@/const";
import { RequestService } from "@/services";
import { PaginationType, RequestMode, ResquestType } from "@/types/common";
import { ResponseRequestType } from "@/types/service";
import { useDataContext } from "@/hooks/useDataContext";

export type InternalResponseFilter = {
  filter?: string;
  startDate?: Date | null;
  endDate?: Date | null;
  applicationSendUid?: string;
  status?: string;
};

export type InternalRequestPayloadType = {
  paginationParam: Partial<PaginationType>;
  filterParams: InternalResponseFilter;
  typeParam: ResquestType;
};

const useSailorResponseList = (props: InternalRequestPayloadType) => {
  const { sailorResponseList } = useDataContext();
  const { paginationParam, filterParams } = props;
  const { page = 1, size = 10 } = paginationParam || {};
  const { filter, startDate, endDate, applicationSendUid, status } = filterParams || {};

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: [KeyConstant.REACT_QUERY.getExternalResponse, page, size, filterParams],
    queryFn: () => {
      return RequestService.getResponse({
        typeResponse: props.typeParam,
        page: page || 1,
        size: size || AppConstant.DEFAULT_SIZE_PAGE,
        startDate: startDate ? dayjs(startDate)?.valueOf() : undefined,
        endDate: endDate ? dayjs(endDate)?.valueOf() : undefined,
        filter: filter,
        applicationSendUid: applicationSendUid === AppConstant.SELECT_ALL ? undefined : applicationSendUid || undefined,
        requestStatus: !Number.isNaN(Number(status)) ? Number(status) : undefined,
      });
    },
  });

  const { data: requestList, ...pagination } = data || {};

  return {
    requestList: requestList || [],
    pagination: pagination,
    isLoading,
    isError,
    refetch,
  };
};

export default useSailorResponseList;
